<template>
    <section>
        <div class="content__wrapper">
            <h4 class="stepper__content__title text-xs-left">{{ $t('IRELAND_AGREEMENT_1') }}</h4>
            <br />
            <p class="stepper__content__title-description">{{ $t('IRELAND_AGREEMENT_2') }}</p>
            <div class="content__wrapper flex-center">
                <div class="flex-center flex-row">
                    <label class="fake-label">
                        <input
                            class="custom-input"
                            type="radio"
                            :value="true"
                            name="radio"
                            v-model="irelandAgreement"
                        />
                        <span class="input-container" style="font-size: 12px;">{{ $t('YES_I_WANT') }}</span>
                        <span class="checkmark"></span>
                    </label>
                    <label class="fake-label">
                        <input
                            class="custom-input"
                            type="radio"
                            :value="false"
                            name="radio"
                            v-model="irelandAgreement"
                        />
                        <span class="input-container" style="font-size: 12px;">{{ $t('NO_I_DO_NOT_WANT') }}</span>
                        <span class="checkmark"></span>
                    </label>
                    <label class="fake-label">
                        <input
                            class="custom-input"
                            type="radio"
                            value="other"
                            name="radio"
                            v-model="irelandAgreement"
                        />
                        <span class="input-container" style="font-size: 12px;">{{ $t('NO_I_DO_NOT_HAVE') }}</span>
                        <span class="checkmark"></span>
                    </label>
                </div>
            </div>
            <form v-if="irelandAgreement === true">
                <div class="col-sm-6">
                    <input
                        class="text-input white-input-border"
                        type="text"
                        :name="$t('NAME')"
                        :placeholder="$t('NAME')"
                        v-validate="{ required: true, regex: /^.+ .+$/ }"
                        v-model="trustedDoctorName"
                    />
                </div>
                <div class="col-sm-6">
                    <input
                        class="text-input white-input-border"
                        type="email"
                        :name="$t('EMAIL_ADDRESS')"
                        :placeholder="$t('EMAIL_ADDRESS')"
                        v-validate="{ required: true, regex: emailRegex }"
                        v-model="trustedDoctorEmail"
                    />
                </div>
            </form>
            <div class="text-center">
                <button
                    v-if="irelandAgreement !== ''"
                    @click="goNext"
                    class="w160 mr-3 app-btn app-btn--small app-btn-primary mt-3"
                >
                    {{ $t('NEXT') }}
                </button>
            </div>
        </div>
    </section>
</template>

<script>
import Steps from './helpers/steps.vue';
import { config } from './../../../main';
import { mapActions, mapState } from 'vuex';

export default {
    name: 'survey-ireland-agreement',
    data() {
        return {
            irelandAgreement: '',
            trustedDoctorName: '',
            trustedDoctorEmail: '',
            emailRegex: config.emailRegex,
        };
    },
    computed: {
        ...mapState(['user']),
    },
    methods: {
        ...mapActions(['updateUserSurvey']),
        goNext() {
            if (this.irelandAgreement === true) {
                this.$validator.validateAll().then(result => {
                    if (result) {
                        const names = this.trustedDoctorName.split(' ');
                        const data = {
                            firstName: names[0],
                            lastName: names[1],
                            email: this.trustedDoctorEmail,
                        };
                        this.$http
                            .post('/user/api/irish/patientAccessHolders/', data)
                            .then(() => this.completeSection(''));
                    }
                });
            } else if (this.irelandAgreement === false) {
                this.completeSection('I do not want to provide the contact information');
            } else {
                this.completeSection('I have not selected any General Practitioner');
            }
        },
        completeSection(noDoctorReason) {
            this.updateUserSurvey({ ...this.user.patient.survey, noDoctorReason }).then(() => {
                this.$store.commit('STATE_SURVEY', {
                    section5: {
                        active_section: 1,
                    },
                    activeStepper: 3,
                });
            });
        },
    },
    components: {
        Steps,
    },
};
</script>



// WEBPACK FOOTER //
// survey-ireland-agreement.vue?3c3178e0